import {ChangeDetectorRef, Component, forwardRef, Input, OnInit} from "@angular/core";
import {Medicine} from "../../model/medicine.type";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {SessionActions} from "../../../shared/actions/session.actions";
import {appInjector} from "../../../index";
import {GERMAN_LAYOUT} from "../../../core/visbos-core/ui/directives/on-screen-keyboard.directive";
import {KeyboardOptions} from "virtual-keyboard";

@Component({
  selector: 'vb-medicine-auth-form',
  templateUrl: './medicine-auth-form.component.html',
  styleUrls: ['./medicine-auth-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => MedicineAuthFormComponent)}],
  inputs: ['control', 'item']
})
export class MedicineAuthFormComponent extends AbstractVisbosControl<Medicine, FormGroup> implements OnInit {

  kbOptions: KeyboardOptions = {
    type: 'input',
    layout: 'custom',
    customLayout: GERMAN_LAYOUT
  };

  @Input()
  touchMode: boolean = false;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions) {
    super(fb, cd, sessionActions);
  }

  buildControlContent(): FormGroup {
    return MedicineAuthFormComponent.initControl(this.fb);
  }

  ngOnInit() {
    super.ngOnInit();

    this.dataSubscriptions.push(this.currentUser$.subscribe(usr => {

      if (this.control) {
        this.control.patchValue({user_id: usr.cuid});
      }

      if (!usr.permissions.find(perm => perm == 'withdraw medicine')) {
        this.addAuthControls();
      } else {
        this.removeAuthControls();
      }

    }));
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [null],
      authenticated_user_cuid: [null, Validators.required],
    });

  }

  setDefaultValues(item?: Medicine): { [controlKey: string]: any } | any {
    return {
      cuid: AbstractVisbosControl.cuid(),
      authenticated_user_cuid: this.currentUser.cuid
    };
  }

  addAuthControls() {
    this.control.addControl('personal_number', this.fb.control(null, Validators.required));
    this.control.addControl('signature', this.fb.control(null, Validators.required));
  }

  removeAuthControls() {
    this.control.removeControl('personal_number');
    this.control.removeControl('signature');
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/withdrawal/medicine-auth-form/medicine-auth-form.component.ts